import { Injectable } from '@angular/core';
import { CustomProductAttributeConfig, Product } from '@ui/products/types';
import { combineLatest, ReplaySubject } from 'rxjs';
import {
  calculateProductPriceFromParams,
  filterOptionsList,
} from '@ui/products/products-front/helpers';
import { printToFrameSizeMap } from 'graphql/libs/look-book-client/src/print-frames/printFramesMap';
import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectPrintFramesInBasket } from '@ui/products/shopping-cart-back/actions/selector';
import { SessionPrintFramesLookBookConfigForDisplay } from '../../../../../../../public-session/src/graphql';
import { LookBookPriceRounding } from '../../../../../../../photographer-panel/src/graphql';

@Injectable({
  providedIn: 'root',
})
export class FramePickerService {
  productSource$ = new ReplaySubject<Product>(1);
  availableCombinations: Record<string, string>[] = [];
  config: SessionPrintFramesLookBookConfigForDisplay;

  set product(product) {
    this.productSource$.next({
      ...product,
      config: JSON.parse(product.config),
    });
    const value: Record<string, string>[] = [];

    const attributes = JSON.parse(
      product.config
    ) as CustomProductAttributeConfig[];

    attributes[0].options
      .filter(({ active }) => active)
      .forEach((size) => {
        attributes[1].options
          .filter(({ active }) => active)
          .forEach((shape) => {
            attributes[2].options
              .filter(({ active }) => active)
              .filter(
                (color) =>
                  filterOptionsList(color.limitations, {
                    cl8d2phqm000435a0pmmalgho: size.configId,
                    cl8d2s4f7000a35a0dkolmwfq: shape.configId,
                  }) &&
                  (!this.config?.limitColors ||
                    this.config?.availableColors.includes(color.configId))
              )
              .forEach((color) => {
                value.push({
                  cl8d2phqm000435a0pmmalgho: size.configId,
                  cl8d2s4f7000a35a0dkolmwfq: shape.configId,
                  cl8d2q86d000735a00p31mc9v: color.configId,
                });
              });
          });
      });

    this.availableCombinations = value;
  }

  constructor(private store: Store) {}

  getOptionsForSize(size) {
    return combineLatest([
      this.productSource$,
      this.store.pipe(select(selectPrintFramesInBasket)),
    ]).pipe(
      map(([product, inBasket]) => {
        return (
          this.availableCombinations
            .filter(
              (combination) =>
                printToFrameSizeMap[size] ===
                combination.cl8d2phqm000435a0pmmalgho
            )
            .map((combination) => {
              return {
                value: combination,

                price: calculateProductPriceFromParams(
                  product,
                  combination,
                  'PLN'
                ),
              };
            })
            .map((v) => ({
              ...v,
              price: ((p) => {
                switch (this.config.rounding) {
                  case LookBookPriceRounding.One:
                    return Math.ceil(p);
                    break;
                  case LookBookPriceRounding.Five:
                    return Math.ceil(p / 5) * 5;
                    break;
                  case LookBookPriceRounding.Ten:
                    return Math.ceil(p / 10) * 10;
                    break;
                }
              })(v.price),
            }))
            // .sort((a, b) => {
            //   if (inBasket.length) {
            //     if (
            //       inBasket.some(
            //         (v) =>
            //           JSON.parse(v.value).cl8d2q86d000735a00p31mc9v ===
            //           a.value.cl8d2q86d000735a00p31mc9v
            //       )
            //     ) {
            //       return -1;
            //     }
            //     if (
            //       inBasket.some(
            //         (v) =>
            //           JSON.parse(v.value).cl8d2q86d000735a00p31mc9v ===
            //           b.value.cl8d2q86d000735a00p31mc9v
            //       )
            //     ) {
            //       return 1;
            //     }
            //     return 0;
            //   }
            //   return b.price - a.price;
            // })
            .map((v) => {
              return {
                ...v,
                price: [
                  {
                    code: 'PLN',
                    price: v.price,
                  },
                ],
              };
            })
        );
      })
    );
  }

  getPrintFrameName(config: Record<string, string>, longName = false) {
    return this.productSource$.pipe(
      map((product) => {
        return product.config
          .filter((v) => Object.keys(config).includes(v.customId))
          .map(
            (v) =>
              v.options
                .find((o) => o.configId === config[v.customId])
                .label.find((l) => l.language === 'pl').text
          )
          .filter((v, i) => (longName ? [0, 2].includes(i) : i === 2))
          .join(' ');
      })
    );
  }
}
